import { render, staticRenderFns } from "./mall-order-list.vue?vue&type=template&id=14b4b712&scoped=true"
import script from "./mall-order-list.vue?vue&type=script&lang=js"
export * from "./mall-order-list.vue?vue&type=script&lang=js"
import style0 from "./mall-order-list.vue?vue&type=style&index=0&id=14b4b712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b4b712",
  null
  
)

export default component.exports